import React from 'react';
import styled from 'styled-components';
import {Form} from 'components/antd';
import {useFormik} from 'formik';
import useSearchParams from '../../useSearchParams';
import {InputNumber} from 'components';

const SerialNumberFilter = () => {
  const {query, setQuery} = useSearchParams();

  const {serialNumber = {from: null, to: null}} = query;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      serialNumber,
    },
    onSubmit: (values) => setQuery(values),
  });

  return (
    <Container>
      <Form.Item>
        <StyledInputNumber
          min={1}
          value={formik.values.serialNumber?.from}
          onChange={(value) => formik.setFieldValue('serialNumber.from', value)}
          onBlur={() => formik.handleSubmit()}
        />
        <span> 〜 </span>
        <StyledInputNumber
          min={1}
          value={formik.values.serialNumber?.to}
          onChange={(value) => formik.setFieldValue('serialNumber.to', value)}
          onBlur={() => formik.handleSubmit()}
        />
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  border: 1px solid rgb(217, 217, 217) !important;
  width: 175px;
`;

export default SerialNumberFilter;
